export default defineNuxtRouteMiddleware(() => {
  if (import.meta.client) {
    if (!Object.keys(globalConfig().location).length > 0) {
      useGetLocByIP();
    }

    if (!useUser().getUser.id && useParkerStore().getParker?.id) {
      useParkerStore().reset();
    }

    if (useUser().getUser.role === 'PARKER' && !useParkerStore().getParker) {
      useParker(useUser().getParkerId);
    }
  }
})
